import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export interface WorkCenterAnnualBag {
  id: number;
  work_center_id: number;
  work_center_name: string;
  year: number;
  vacation_days: number;
  flexible_hours: number;
  holidays_count: number;
  notes?: string;
  created_at: string;
  updated_at?: string;
}

export interface WorkCenterAnnualBagCreate {
  work_center_id: number;
  year: number;
  vacation_days: number;
  flexible_hours: number;
  holidays_count: number;
  notes?: string;
}

export interface WorkCenterAnnualBagUpdate {
  vacation_days?: number;
  flexible_hours?: number;
  holidays_count?: number;
  notes?: string;
}

export const workCenterAnnualBagsApi = {
  getAll: async (year?: number, workCenterId?: number): Promise<WorkCenterAnnualBag[]> => {
    const params = new URLSearchParams();
    if (year) params.append('year', year.toString());
    if (workCenterId) params.append('work_center_id', workCenterId.toString());
    
    const response = await axios.get(`${API_BASE_URL}/work-center-annual-bags/?${params}`);
    return response.data;
  },

  create: async (data: WorkCenterAnnualBagCreate): Promise<WorkCenterAnnualBag> => {
    const response = await axios.post(`${API_BASE_URL}/work-center-annual-bags/`, data);
    return response.data;
  },

  update: async (id: number, data: WorkCenterAnnualBagUpdate): Promise<WorkCenterAnnualBag> => {
    const response = await axios.put(`${API_BASE_URL}/work-center-annual-bags/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axios.delete(`${API_BASE_URL}/work-center-annual-bags/${id}`);
  }
};